import { FormControl } from "@mui/material";

import { FieldLabel } from "ui/forms/field-label/field-label";
import {
  FieldErrorMessage,
  FieldHelperText,
  FieldWarningMessage,
} from "ui/forms/field-message/field-message";
import { visibleFieldMessages } from "ui/forms/field-message/field-message.helpers";
import { FIELD_STACK_SX } from "ui/forms/input-control/input-control.styles";
import { mergeSx } from "ui/merge-sx";
import { type InputControlProps } from "ui/forms/input-control/input-control.types";

export const InputControl = ({
  children,
  errorMessage,
  helperText,
  id,
  disabled,
  error,
  required,
  label,
  infoTooltip,
  warningMessage,
  size = "medium",
  sx,
}: InputControlProps) => {
  const visible = visibleFieldMessages({ errorMessage, helperText, warningMessage });

  return (
    <FormControl
      fullWidth
      error={!!errorMessage || !!error}
      disabled={!!disabled}
      required={!!required}
      sx={mergeSx(FIELD_STACK_SX[size], sx)}>
      {label && (
        <FieldLabel name={id} infoTooltip={infoTooltip} size={size}>
          {label}
        </FieldLabel>
      )}
      {children}
      {visible.error && <FieldErrorMessage name={id} message={errorMessage} />}
      {visible.helperText && <FieldHelperText name={id} message={helperText} />}
      {visible.warning && <FieldWarningMessage name={id} message={warningMessage} />}
    </FormControl>
  );
};
